const Hours = Array.from(Array(24).keys(), (i) => {
  const formattedId = `${i}`.padStart(2, '0');
  let formattedName;

  if (i - 12 < 0) {
    formattedName = i === 0 ? '12am' : `${i}am`;
  } else {
    i -= 12;
    formattedName = i === 0 ? '12pm' : `${i}pm`;
  }
  return { id: formattedId, name: formattedName };
});

export default Hours;



// WEBPACK FOOTER //
// ./src/views/StaticData/Hours.tsx